import { isNull, isUndefined, set } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { initialValuationPercentageFilter } from '../../../../constants/instanceFilters';
import { Comparator, ValuationPercentageFilterType } from '../../store/filterTypes';
import { ComparatorFilter } from './ComparatorFilter';
import { SharedNumberFilter } from './SharedNumberFilter';
import styles from './TableInstanceFilters.module.scss';
import { ToggleFilter } from './ToggleFilter';

interface ValuationPercentageFilterProps {
    updateFilter: (value: ValuationPercentageFilterType) => void;
    removeFilter: () => void;
    filter: ValuationPercentageFilterType | null;
    testId: string;
}

export const ValuationPercentageFilter: React.FC<ValuationPercentageFilterProps> = ({ updateFilter, removeFilter, filter, testId }) => {
    const valuationFilter = useMemo(() => isNull(filter) ? initialValuationPercentageFilter : filter, [filter]);
    const { comparator, percentage, containsMaturity } = valuationFilter;

    const updateValuationFilter = useCallback((key: keyof ValuationPercentageFilterType, value: number | Comparator | undefined | null | boolean) => {
        if ((key === 'percentage' && isUndefined(value) && isUndefined(containsMaturity) && isNull(comparator)) || (key === 'comparator' && isNull(value) && isUndefined(percentage) && isUndefined(containsMaturity)) || (key === 'containsMaturity' && isUndefined(value) && isUndefined(percentage) && isNull(comparator))) {
            removeFilter();
            return;
        }
        const updatedFilter = set(key, value, valuationFilter);
        updateFilter(updatedFilter);
    }, [removeFilter, updateFilter, valuationFilter, comparator, containsMaturity, percentage]);

    const updateComparatorFilter = useCallback((value: Comparator | null) => updateValuationFilter('comparator', value), [updateValuationFilter]);
    const updateContainsMaturityFilter = useCallback((value: boolean | undefined) => updateValuationFilter('containsMaturity', value), [updateValuationFilter]);

    const updateNumberValue = useCallback((value: number | undefined) => updateValuationFilter('percentage', value), [updateValuationFilter]);

    return (
        <div className={styles.valuationFilterWrapper}>
            <div className={styles.verticalFilterLabel}>Maturity</div>
            <ToggleFilter filter={containsMaturity} testId={testId} updateFilter={updateContainsMaturityFilter} labels={['Contains Maturity', 'No Maturity']} marginBottom='10px' />
            <div className={styles.verticalFilterLabel}>Percentage</div>
            <div className={styles.comparatorSplitWrapper}>
                <ComparatorFilter updateFilter={updateComparatorFilter} filter={comparator} testId={testId} />
                <SharedNumberFilter updateFilter={updateNumberValue} filter={percentage} testId={testId} placeholder='Percentage...' />
            </div>
        </div>
    );
};
